import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, lifecycle, withProps } from 'recompose';
import { filters as filtersAPI } from 'api';
import reducers, { getIsFetching, getMainFiltersByGroup, getAllFiltersByGroup } from './reducers';
import { resetFiltersListApiHOC } from './actions';

const FiltersListApiHOC = () => WrappedComponent => compose(
  connect(
    state => ({
      _filtersListApiHOC_state: {
        filters: getMainFiltersByGroup(state),
        allFilters: getAllFiltersByGroup(state),
        isFiltersListFetching: getIsFetching(state),
      },
    }),

    dispatch => ({
      _filtersListApiHOC_actions: {
        getFilters: bindActionCreators(filtersAPI.actions.getFilters, dispatch),
        resetFiltersList: bindActionCreators(resetFiltersListApiHOC, dispatch),
      },
    }),
  ),

  /* eslint-disable no-underscore-dangle */
  withProps(
    props => ({
      filtersListApiHOC: {
        ...props._filtersListApiHOC_state,
        ...props._filtersListApiHOC_actions,
      },
    }),
  ),
  /* eslint-enable no-underscore-dangle */

  lifecycle({
    componentDidMount() {
      this.props.filtersListApiHOC.getFilters();
    },
  }),
)(WrappedComponent);

export { reducers };

export default FiltersListApiHOC;



// WEBPACK FOOTER //
// ./src/components/apiHOCs/FiltersListApiHOC/index.js